// extracted by mini-css-extract-plugin
export var resizer = "_hr-0";